import React, { useState, useEffect } from 'react';
import api from '../../services/api';

function ProductSelector({ selected = [], onChange }) {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedCategories, setExpandedCategories] = useState({});

  useEffect(() => {
    loadProducts();
  }, []);
const loadProducts = async () => {
    try {
      const [catData, prodData] = await Promise.all([
        api.getMasterData('categories'),
        api.getMasterData('products')
      ]);
      console.log('Categories loaded:', catData);
      console.log('Products loaded:', prodData);
      
      setCategories(catData || []);
      setProducts(prodData || []);
      
      // Group products by category
      const subs = {};
      catData?.forEach(cat => {
        subs[cat.id] = prodData?.filter(p => p.category_id === cat.id) || [];
      });
      setSubcategories(subs);
      
      // Auto-expand categories that have selected products
      if (selected && selected.length > 0) {
        const expanded = {};
        catData?.forEach(cat => {
          const hasSelected = subs[cat.id]?.some(p => selected.includes(p.name));
          if (hasSelected) {
            expanded[cat.id] = true;
          }
        });
        setExpandedCategories(expanded);
      }
      
    } catch (err) {
      console.error('Failed to load products:', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!categories.length || !products.length) return;
    const selectedNames = (Array.isArray(selected) ? selected : []).map(v => typeof v === 'string' ? v : v?.name).filter(Boolean);
    const expanded = {};
    categories.forEach(cat => {
      const hasSelected = products.some(p => p.category_id === cat.id && selectedNames.includes(p.name));
      if (hasSelected) expanded[cat.id] = true;
    });
    setExpandedCategories(prev => ({ ...prev, ...expanded }));
  }, [selected, categories, products]);


  const toggleCategory = (categoryId) => {
    setExpandedCategories({
      ...expandedCategories,
      [categoryId]: !expandedCategories[categoryId]
    });
  };

  const handleProductToggle = (productName) => {
    const current = Array.isArray(selected) ? selected : [];
    let newSelected;
    if (current.includes(productName)) {
      newSelected = current.filter(p => p !== productName);
    } else {
      newSelected = [...current, productName];
    }
    console.log('Products selection changed:', newSelected);
    onChange(newSelected);
  };

  if (loading) return <div>Loading products...</div>;

  return (
    <div className="product-selector">
      {categories.map((category) => {
        const categoryProducts = subcategories[category.id] || [];
        const selectedNames = (Array.isArray(selected) ? selected : []).map(v => typeof v === 'string' ? v : v?.name).filter(Boolean);
        const selectedCount = categoryProducts.filter(p => selectedNames.includes(p.name)).length;
        
        return (
          <div key={category.id} className="product-category">
            <div
              className="category-header"
              onClick={() => toggleCategory(category.id)}
            >
              <i className={`fas fa-${expandedCategories[category.id] ? 'chevron-down' : 'chevron-right'}`}></i>
              <span>{category.name}</span>
              {selectedCount > 0 && (
                <span className="badge badge-primary">{selectedCount} selected</span>
              )}
            </div>
            
            {expandedCategories[category.id] && (
              <div className="product-list">
                {categoryProducts.map((product) => {
                  const isSelected = Array.isArray(selected) && selected.some(v => (typeof v === 'string' ? v : v?.name) === product.name);
                  return (
                    <div
                      key={product.id}
                      className={`product-item ${isSelected ? 'selected' : ''}`}
                      onClick={() => handleProductToggle(product.name)}
                    >
                      <span>{product.name}</span>
                      {isSelected && (
                        <i className="fas fa-check-circle"></i>
                      )}
                    </div>
                  );
                })}
                {categoryProducts.length === 0 && (
                  <div className="empty-message">No products in this category</div>
                )}
              </div>
            )}
          </div>
        );
      })}
      
      {categories.length === 0 && (
        <div className="empty-message">No categories available</div>
      )}
    </div>
  );
}

export default ProductSelector;